import { useAppSelector } from '@user/store/hooks/useAppSelector'
import { selectMapEntityDetails } from '@user/store/map/slice'
import { selectAllKnockStatuses } from '@user/store/knockStatus/slice'
import { useMemo } from 'react'

export type FormValues = {
  knockStatus: string
  note: string
}

export function useData() {
  const entityDetails = useAppSelector(selectMapEntityDetails)
  const allStatuses = useAppSelector(selectAllKnockStatuses)

  const initialValues = useMemo(() => {
    return {
      knockStatus: '',
      note: '',
    }
  }, [])

  return {
    initialValues,
    allStatuses,
    entityDetails,
  }
}
